const middleware = {}

middleware['301redirects'] = require('../middleware/301redirects.js')
middleware['301redirects'] = middleware['301redirects'].default || middleware['301redirects']

middleware['check-config'] = require('../middleware/check-config.ts')
middleware['check-config'] = middleware['check-config'].default || middleware['check-config']

middleware['checkout'] = require('../middleware/checkout.js')
middleware['checkout'] = middleware['checkout'].default || middleware['checkout']

middleware['initialSettings'] = require('../middleware/initialSettings.ts')
middleware['initialSettings'] = middleware['initialSettings'].default || middleware['initialSettings']

middleware['injectLocale'] = require('../middleware/injectLocale.ts')
middleware['injectLocale'] = middleware['injectLocale'].default || middleware['injectLocale']

middleware['is-anonymous-cart'] = require('../middleware/is-anonymous-cart.ts')
middleware['is-anonymous-cart'] = middleware['is-anonymous-cart'].default || middleware['is-anonymous-cart']

middleware['is-authenticated'] = require('../middleware/is-authenticated.ts')
middleware['is-authenticated'] = middleware['is-authenticated'].default || middleware['is-authenticated']

middleware['is-not-authenticated'] = require('../middleware/is-not-authenticated.ts')
middleware['is-not-authenticated'] = middleware['is-not-authenticated'].default || middleware['is-not-authenticated']

middleware['location-redirectFunc'] = require('../middleware/location-redirectFunc.ts')
middleware['location-redirectFunc'] = middleware['location-redirectFunc'].default || middleware['location-redirectFunc']

middleware['redirectWrapper'] = require('../middleware/redirectWrapper.ts')
middleware['redirectWrapper'] = middleware['redirectWrapper'].default || middleware['redirectWrapper']

middleware['restrict-page-direct-access'] = require('../middleware/restrict-page-direct-access.js')
middleware['restrict-page-direct-access'] = middleware['restrict-page-direct-access'].default || middleware['restrict-page-direct-access']

middleware['validateQueueIT'] = require('../middleware/validateQueueIT.js')
middleware['validateQueueIT'] = middleware['validateQueueIT'].default || middleware['validateQueueIT']

middleware['www-injectionFunc'] = require('../middleware/www-injectionFunc.ts')
middleware['www-injectionFunc'] = middleware['www-injectionFunc'].default || middleware['www-injectionFunc']

export default middleware
